/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type TaskDetailStatus = typeof TaskDetailStatus[keyof typeof TaskDetailStatus];


export const TaskDetailStatus = {
  pending: 'pending',
  scheduled: 'scheduled',
  executing: 'executing',
  done: 'done',
  archived: 'archived',
  failed: 'failed',
} as const;
